const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content integration config
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {ContentIntegrations} ContentIntegrations injected to gain access to the ContentIntegrations resource
 */
app.directive('contentIntegrationConfig', ['Application', 'Authorization', 'ContentIntegrations', function (Application, Authorization, ContentIntegrations) {
  return {
    restrict: "E",
    replace: true,
    scope : {
      type: "@"
    },
    template: require('../../templates/directives/content-integration-config.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.newSettings = {};
      self.activeTab = 'edit';
      self.editing = false;
      self.configured = false;
      self.integrationId = '';

      self.typeMap = {
        udemy: 'Udemy',
        linkedin_learning: 'Linkedin Learning',
        masterclass: 'Masterclass'
      };

      self.typeCopy = self.typeMap[$scope.type] || 'Content integration';

      self.cancel = function() {
        self.newSettings.id = '';
        self.newSettings.secret = '';
        self.newSettings.portal = '';
        self.newSettings.portalId = '';
        self.activeTab = 'edit';
      };

      self.update = function() {
        if (!self.newSettings.id || !self.newSettings.secret) {
          Application.messaging.addMessage({type: 'error', text: 'Please fill out all fields.', duration: 5});
          return;
        }

        var body = {
          integration_info: [
            {name: 'id', value: self.newSettings.id},
            {name: 'secret', value: self.newSettings.secret}
          ]
        };

        if ($scope.type === 'udemy') {
          body.integration_info.push({name: 'portal_name', value: self.newSettings.portalName});
          body.integration_info.push({name: 'portal_id', value: self.newSettings.portalId});
        }

        self.loading = true;
        ContentIntegrations.update({subresource: self.integrationId}, body).$promise.then(function(data) {
          Application.messaging.addMessage({type: 'success', text: 'The ' + (self.typeMap[$scope.type] || 'Content integration') + ' integration has been successfully updated.', duration: 5});
          self.cancel();
          self.loading = false;
        }).catch(function(err) {
          Application.messaging.addMessage({type: 'error', text: 'There was an error in updating the ' + (self.typeMap[$scope.type] || 'Content integration') + ' configuration.', duration: 5});
        });
      };

      self.create = function() {
        if (!self.newSettings.id || !self.newSettings.secret) {
          Application.messaging.addMessage({type: 'error', text: 'Please fill out all fields.', duration: 5});
          return;
        }
        self.loading = true;
        var body = {
          integration_name: $scope.type,
          integration_info: [
            {name: 'id', value: self.newSettings.id},
            {name: 'secret', value: self.newSettings.secret},
          ]
        };

        if ($scope.type === 'udemy') {
          body.integration_info.push({name: 'portal_name', value: self.newSettings.portalName});
          body.integration_info.push({name: 'portal_id', value: self.newSettings.portalId});
        }

        ContentIntegrations.create({}, body).$promise.then(function(data) {
          Application.messaging.addMessage({type: 'success', text: 'The ' + (self.typeMap[$scope.type] || 'Content integration') + ' configuration has been successfully created.', duration: 5});
          self.cancel();
          self.configured = true;
          self.loading = false;
        }).catch(function(err) {
          Application.messaging.addMessage({type: 'error', text: 'There was an error in setting the ' + (self.typeMap[$scope.type] || 'Content integration') + ' configuration.', duration: 5});
        });
      };

      self.initialize = function() {
        self.loading = true;
        if (!self.user || !self.user.role || self.user.role !== 'admin') {
          Application.navigation.back();
          return;
        }
        self.editing = false;
        ContentIntegrations.exists({name: $scope.type}).$promise.then(function(settings) {
          if (settings && settings.exists) {
            self.editing = true;
            self.configured = true;
            self.integrationId = settings.integration_id;
          }
          self.loading = false;
        }).catch(function(err) {
          Application.messaging.addMessage({type: 'error', text: 'There was an error retrieving the ' + (self.typeMap[$scope.type] || 'Content integration') + ' configuration.', duration: 5});
          self.loading = false;
          console.log(err);
        });
      };

      self.initialize();

    }],
    controllerAs: 'contentConfig'
  }
}]);